import {forOnlyId, getPasswordSettings, PasswordValidatorId} from './PasswordSettings'
import Validators from './PasswordValidators'

/**
 * Knows how to render password settings tips and error messages
 */
const PasswordPolicyManager = {

    getErrorMessage({
        settings = getPasswordSettings(),
        violatedRules = []
    }) {
        let violatedRulesSet = new Set(violatedRules);
        let messages = [];
        for (let validator of this.validators) {
            validator.addMessage(messages, violatedRulesSet, settings);
        }
        return messages[0];
    },


    validators: Validators,

    getSingleTipFor(id, settings = getPasswordSettings()) {
        return this.getPasswordTips(forOnlyId(settings, id))[0];
    },

    getPasswordTips(settings = getPasswordSettings()) {
        let tips = [];
        for (let validator of this.validators) {
            validator.addTips(tips, settings);
        }
        return tips;
    },

    hasPasswordRequirements() {
        return true
    },

    hasSpecialCharacter() {
        return getPasswordSettings().ruleIds.includes(PasswordValidatorId.SPECIAL_VALIDATOR)
    }
}

export default PasswordPolicyManager




// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordPolicyManager.js